module.exports = __webpack_public_path__ + "static/img/data.0c9bbfc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/data.jpeg
// module id = qTEo
// module chunks = 13